import React from "react";
import { useQuery, useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form, Field } from "react-final-form";
import { DateField, TextField } from "@syos-music/form";

import {
  Autocomplete,
  Box,
  Stack,
  TextField as MuiTextField,
} from "@mui/material";

import SaveFab from "components/common/SaveFab";

OrderToolbar.fragments = {
  order: gql`
    fragment OrderToolbar_order on Order {
      id
      deadline
      label
      state {
        id
        label
      }
    }
  `,
};

const MUTATION = gql`
  mutation ($orderId: ID!, $stateId: ID!, $deadline: Date, $label: String) {
    UpdateOrderAdmin(
      orderId: $orderId
      stateId: $stateId
      deadline: $deadline
      label: $label
    ) {
      order {
        id

        ...OrderToolbar_order
      }
    }
  }

  ${OrderToolbar.fragments.order}
`;

const QUERY = gql`
  query {
    orderStates {
      id
      label
    }
  }
`;

export default function OrderToolbar({ order }) {
  const [updateOrderState] = useMutation(MUTATION, {
    variables: { orderId: order.id },
  });
  const handleSubmit = React.useCallback(
    (values) =>
      updateOrderState({ variables: values })
        .then(() => {})
        .catch(() => true),
    [updateOrderState]
  );

  const { data } = useQuery(QUERY);
  const orderStates = data?.orderStates ?? [order.state];

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{
        stateId: order.state.id,
        deadline: order.deadline
          ? new Date(order.deadline).toISOString()
          : null,
        label: order.label,
      }}
      keepDirtyOnReinitialize
    >
      {({ handleSubmit, pristine, submitting, form, values }) => (
        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
          <Stack spacing={1} direction="row" alignItems="center">
            <SaveFab
              onSave={handleSubmit}
              disabled={pristine}
              loading={submitting}
            />

            <Box sx={{ width: 200 }}>
              <Field
                name="stateId"
                format={(stateId) =>
                  orderStates.find(({ id }) => id === stateId) ?? null
                }
                parse={({ id }) => id}
              >
                {({ input }) => (
                  <Autocomplete
                    disablePortal
                    disableClearable
                    onChange={(e, value) => input.onChange(value)}
                    value={input.value}
                    options={orderStates}
                    sx={{
                      "& ~ * .MuiAutocomplete-listbox": { maxHeight: "80vh" },
                    }}
                    renderInput={(params) => (
                      <MuiTextField {...params} label="Colonne" />
                    )}
                  />
                )}
              </Field>
            </Box>

            <Box>
              <DateField
                name="deadline"
                label="Deadline"
                parse={(value) => value ?? null}
              />
            </Box>

            <Box sx={{ width: 200 }}>
              <TextField name="label" clearable label="Libellé" />
            </Box>
          </Stack>
        </form>
      )}
    </Form>
  );
}
